// Session SC9A: the client mirror of server/src/lib/jobHold.ts (the fixed hold reasons and the words a person reads), bound by
// server/src/lib/jobHold.test.ts. The job's status stays parts_pending; the reason is separate.
export const JOB_HOLD_REASONS = ["awaiting_parts", "no_access", "awaiting_customer_approval", "other"] as const;
export type JobHoldReasonKey = (typeof JOB_HOLD_REASONS)[number];

/** The words after "On hold: ". */
export const JOB_HOLD_REASON_LABELS: Record<JobHoldReasonKey, string> = {
  awaiting_parts: "awaiting parts",
  no_access: "no access",
  awaiting_customer_approval: "awaiting the customer's approval",
  other: "other",
};

/** The picker's options, sentence case. */
export const JOB_HOLD_REASON_OPTIONS: Array<{ value: JobHoldReasonKey; label: string }> = [
  { value: "awaiting_parts", label: "Awaiting parts" },
  { value: "no_access", label: "No access" },
  { value: "awaiting_customer_approval", label: "Awaiting the customer's approval" },
  { value: "other", label: "Other (say why in a few words)" },
];

/** A null reason is an older pause, which only ever meant parts. */
export function effectiveHoldReason(reason: JobHoldReasonKey | null | undefined): JobHoldReasonKey {
  return reason ?? "awaiting_parts";
}

/** "On hold: awaiting parts". For Other the person's own words follow. */
export function holdLabel(reason: JobHoldReasonKey | null | undefined, text?: string | null): string {
  const r = effectiveHoldReason(reason);
  const words = r === "other" && text && text.trim() ? text.trim() : JOB_HOLD_REASON_LABELS[r];
  return `On hold: ${words}`;
}
